import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { PageHero } from "@/components/Blocks";
import ConsultationForm from "@/components/ConsultationForm";
import { Reveal } from "@/components/motion";
import { CONTACT } from "@/data/content";

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <PageHero
        testId="contact-hero"
        eyebrow="Enquiries & consultations"
        lines={["Book a confidential", "consultation."]}
        intro="Choose how you would like to meet, pick a date and time in your own time zone, and we will confirm discreetly."
      />
      <section className="bg-[#070A12] pb-28">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-8 order-1">
            <ConsultationForm />
          </div>
          <aside className="lg:col-span-4 order-2 lg:sticky lg:top-28 self-start space-y-4">
            <Reveal className="bg-[#131B2E] border border-[#C5A059]/20 p-8">
              <p className="eyebrow mb-6">Direct contact</p>
              <ul className="space-y-5 text-sm text-slate-200">
                <li className="flex gap-3" data-testid="contact-phone"><Phone className="w-4 h-4 text-[#C5A059] mt-0.5" /> {CONTACT.phone}</li>
                <li className="flex gap-3" data-testid="contact-email"><Mail className="w-4 h-4 text-[#C5A059] mt-0.5" /> {CONTACT.email}</li>
                <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#C5A059] mt-0.5" /> No. 2 Harley Street, London</li>
                <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#C5A059] mt-0.5" /> Mountain Retreat, Andalusia, Spain</li>
              </ul>
            </Reveal>
            <Reveal delay={0.1} className="border border-red-400/30 bg-red-500/5 p-8">
              <p className="font-data text-[11px] tracking-[0.25em] uppercase text-red-300 flex items-center gap-3"><span className="pulse-dot w-2 h-2 rounded-full bg-red-500" /> Recent incident?</p>
              <p className="mt-4 text-sm text-slate-300 leading-relaxed">If something has happened in the last few hours or days, use our immediate support service.</p>
              <Link to="/immediate-support" data-testid="contact-immediate-support-link" className="mt-5 inline-block text-sm text-red-200 link-underline pb-1">Immediate post-incident support →</Link>
            </Reveal>
          </aside>
        </div>
      </section>
    </main>
  );
}
